import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Login from "./auth/Login";
import withPublicLayout from "./hocs/withPublicLayout";
import withMainLayout from "./hocs/withMainLayout";
import "react-quill/dist/quill.snow.css";
import "katex/dist/katex.min.css";
import "highlight.js/styles/github.css"; // or any other style you prefer
import { DialogSubscriber } from "./layouts/DialogSubscriber";
import Contracts from "./pages/contract/Contracts";
import CreateContract from "./pages/contract/CreateContract";
import EditContract from "./pages/contract/EditContract";
import ContractDetail from "./pages/contract/ContractDetail";
import Bikes from "./pages/bike/Bikes";
import CreateBike from "./pages/bike/CreateBike";
import EditBike from "./pages/bike/EditBike";
import BikeExpenses from "./pages/bike/BikeExpenses";
import GeneralExpenses from "./pages/expense/GeneralExpenses";

const App = () => {
  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={withPublicLayout(Login)()} />
            <Route path="/contracts" element={withMainLayout(Contracts)()} />
            <Route path="/contracts/new" element={withMainLayout(CreateContract)()} />
            <Route path="/contracts/:id/edit" element={withMainLayout(EditContract)()} />
            <Route path="/contracts/:id" element={withMainLayout(ContractDetail)()} />
            
            {/* Bike routes */}
            <Route path="/bikes" element={withMainLayout(Bikes)()} />
            <Route path="/bikes/new" element={withMainLayout(CreateBike)()} />
            <Route path="/bikes/:id" element={withMainLayout(EditBike)()} />
            <Route path="/bikes/:id/expenses" element={withMainLayout(BikeExpenses)()} />
            <Route path="/expenses" element={withMainLayout(GeneralExpenses)()} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
      <DialogSubscriber />
    </>
  );
};

export default App;
